import { useQuery } from '@tanstack/react-query';
import { IAggregateActiveUse } from '../../../models/AdminModels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { IAccountsFilterRequest } from '../../../viewmodels/AdminViewModels';

const BASE_QUERY_KEY = `admin/account/stats`;

export function useAdminAccountStats({ filter }: { filter: IAccountsFilterRequest }) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [BASE_QUERY_KEY, filter],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<IAggregateActiveUse>({
				path: `admin/account/stats`,
				method: 'POST',
				body: filter,
				throwOn404: false,
			}),
	});
}
